
// src/stores/UseInstanceStore.js
import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'


export const useInstanceStore = create(
  persist(
    (set) => ({
      instance: {
        portfolioName: null,
        portfolioId: null,
        jwtToken: null,
        refreshToken: null,
        apiBaseUrl: null,
        userSub: null,  // Track the current user's subject (wallet address)
        promptMode: 'basic',  // Track prompt mode preference ('basic' or 'trader')
        activeTab: 0,  // Track active tab index for TabsExtended
        agentKeyVersion: 0,  // Bumped whenever an agent key is saved; triggers re-fetch in consumers
        // Research state
        researchTicketId: null,          // UUID string | null — in-flight ticket
        researchPollDone: false,         // true when last run finished
        researchLatestResultId: null,    // int | null — ID of latest completed result
        onboardingCompleted: false,      // true after onboarding wizard finishes
        incitersCtaDeclinedSubs: [],     // wallet subs that have dismissed the INCITERS co-heart CTA (per-wallet)
        // other attributes can go here
      },
      _hasHydrated: false,
      setHasHydrated: (state) => set({ _hasHydrated: state }),
        setPortfolioName: (name) =>
          set((state) => ({
            instance: { ...state.instance, portfolioName: name },
          })),
        setPortfolioId: (id) =>
          set((state) => ({
            instance: { ...state.instance, portfolioId: id },
          })),
        setJwtToken: (token) =>
          set((state) => ({
            instance: { ...state.instance, jwtToken: token },
          })),
        clearJwtToken: () =>
          set((state) => ({
            instance: { ...state.instance, jwtToken: null },
          })),
        setRefreshToken: (token) =>
          set((state) => ({
            instance: { ...state.instance, refreshToken: token },
          })),
        clearRefreshToken: () =>
          set((state) => ({
            instance: { ...state.instance, refreshToken: null },
          })),
        clearAuthTokens: () =>
          set((state) => ({
            instance: { ...state.instance, jwtToken: null, refreshToken: null },
          })),
        setApiBaseUrl: (url) =>
          set((state) => ({
            instance: { ...state.instance, apiBaseUrl: url },
          })),
        setUserSub: (sub) =>
          set((state) => ({
            instance: { ...state.instance, userSub: sub },
          })),
        clearUserSub: () =>
          set((state) => ({
            instance: { ...state.instance, userSub: null },
          })),
        setPromptMode: (mode) =>
          set((state) => ({
            instance: { ...state.instance, promptMode: mode },
          })),
        setActiveTab: (index) =>
          set((state) => ({
            instance: { ...state.instance, activeTab: index },
          })),
        bumpAgentKeyVersion: () =>
          set((state) => ({
            instance: { ...state.instance, agentKeyVersion: (state.instance.agentKeyVersion || 0) + 1 },
          })),
        // Research actions
        setResearchTicketId: (id) =>
          set((state) => ({
            instance: { ...state.instance, researchTicketId: id },
          })),
        setResearchPollDone: (done) =>
          set((state) => ({
            instance: { ...state.instance, researchPollDone: done },
          })),
        setResearchLatestResultId: (id) =>
          set((state) => ({
            instance: { ...state.instance, researchLatestResultId: id },
          })),
        setOnboardingCompleted: (done) =>
          set((state) => ({
            instance: { ...state.instance, onboardingCompleted: done },
          })),
        declineIncitersCtaForSub: (sub) =>
          set((state) => {
            if (!sub) return state;
            const normalized = sub.toLowerCase();
            const existing = state.instance.incitersCtaDeclinedSubs || [];
            if (existing.includes(normalized)) return state;
            return {
              instance: {
                ...state.instance,
                incitersCtaDeclinedSubs: [...existing, normalized],
              },
            };
          }),
    }),
    {
      name: 'tubman-bobtail-instance', // key in localStorage
      storage: createJSONStorage(() => localStorage),
      onRehydrateStorage: () => (state) => {
        // Called when rehydration is complete
        state?.setHasHydrated(true);
        console.log('Zustand store rehydrated, portfolioId:', state?.instance?.portfolioId);
      },
    }
  )
)
